import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0001',
    ecrans: ['00-2',
             '01-2']
});
